/* eslint-disable semi */

/**
 * 年月日
 * @param {*} value
 */
export function ymd (value) {
  if (value === null || value === undefined) {
    return value
  }
  if (value.match(/^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/) || value.match(/^[0-9]{4}\/[0-9]{2}\/[0-9]{2} .*/)) {
    return value.substr(0, 10);
  } else {
    return value;
  }
};

/**
 * 年月
 * @param {*} value
 */
export function ym (value) {
  if (value === null || value === undefined) {
    return value
  }
  if (value.match(/^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/) || value.match(/^[0-9]{4}\/[0-9]{2}\/[0-9]{2} .*/)) {
    return value.substr(0, 7);
  } else {
    return value;
  }
};



// WEBPACK FOOTER //
// ./src/app/filters/ymd.js